import { render, staticRenderFns } from "./Deactivated.vue?vue&type=template&id=687efbeb&scoped=true&"
import script from "./Deactivated.vue?vue&type=script&lang=js&"
export * from "./Deactivated.vue?vue&type=script&lang=js&"
import style0 from "./Deactivated.vue?vue&type=style&index=0&id=687efbeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687efbeb",
  null
  
)

export default component.exports